import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import {MediciValidationsAgainModalDispatchProps} from '../types/containers';
import MediciValidationsAgainModalView from '../components/views/MediciValidationsAgainModalView';
import {SEND_MEDICI_VALIDATION_EMAIL_ACTION} from '../actions/MediciValidationsStepActions';

const mapStateToProps = (state: State) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): MediciValidationsAgainModalDispatchProps => {
    return {
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
        onPressSendAgain: ()  => {
            dispatch(SEND_MEDICI_VALIDATION_EMAIL_ACTION.action());
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const MediciValidationsAgainModalContainer = connect(
    mapStateToProps, mapDispatchToProps,
)(MediciValidationsAgainModalView);

export default MediciValidationsAgainModalContainer;
